import { FC } from "react";
import { useAuth } from "../context/AuthContext";
import { isTokenValid } from "../utils/authHelpers";

const AdminProtectedRoute: FC<AdminProtectedRouteProps> = ({ children }) => {
  const { logout, isAdmin } = useAuth();
  const token = localStorage.getItem("token");

  if (!isTokenValid(token) && !isAdmin) {
    logout();
  }

  return children;
};

export default AdminProtectedRoute;

interface AdminProtectedRouteProps {
  children: JSX.Element;
}
